<p-drawer [(visible)]="visible" [position]="drawerPosition" [baseZIndex]="10000" [showCloseIcon]="false"
  styleClass="sup-sidebar" (onHide)="closeSidebar()">
  <div class="sup-drawer">
    <div class="drawer-head">
      <span class="drawer-title">{{'app.support' | translate}}</span>
      <button type="button" class="drawer-close" (click)="closeSidebar()"
        [attr.aria-label]="'app.close' | translate">
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M18 6L6 18M6 6l12 12" />
        </svg>
      </button>
    </div>

    <div class="drawer-body">
      <div class="sup-list">
        <button type="button" class="sup-btn red" (click)="createRequest('assistence')">
          <span class="ic">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M12 5v14M5 12h14" />
            </svg>
          </span>
          <span class="txt">{{'app.new-request' | translate}}</span>
        </button>

        <button type="button" class="sup-btn red" (click)="createRequest('feedback')">
          <span class="ic">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path
                d="M9 18h6M10 22h4M12 2a7 7 0 0 0-4 12.7c.6.5 1 1.3 1 2.1V18h6v-1.2c0-.8.4-1.6 1-2.1A7 7 0 0 0 12 2z" />
            </svg>
          </span>
          <span class="txt">{{'app.feedback' | translate}}</span>
        </button>

        <button type="button" class="sup-btn red" (click)="createRequest('technical')">
          <span class="ic">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M14.7 6.3a4 4 0 0 0 5 5l-9.4 9.4a2.1 2.1 0 0 1-3-3l9.4-9.4z" />
            </svg>
          </span>
          <span class="txt">{{'app.technical-problem' | translate}}</span>
        </button>

        <button type="button" class="sup-btn orange" (click)="downloadLivelet()">
          <span class="ic">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M12 3v12M7 10l5 5 5-5M5 21h14" />
            </svg>
          </span>
          <span class="txt">{{'app.download-software' | translate}}</span>
        </button>
      </div>
    </div>
  </div>
</p-drawer>
